var OntoTooltipPlacement;
(function (OntoTooltipPlacement) {
    OntoTooltipPlacement["LEFT"] = "left";
    OntoTooltipPlacement["RIGHT"] = "right";
    OntoTooltipPlacement["TOP"] = "top";
    OntoTooltipPlacement["BOTTOM"] = "bottom";
    OntoTooltipPlacement["AUTO"] = "auto";
})(OntoTooltipPlacement || (OntoTooltipPlacement = {}));

export { OntoTooltipPlacement as O };
